import { autoserialize, inheritSerialization } from 'cerialize';
import { AbstractModel } from './abstract-model';

@inheritSerialization(AbstractModel)
export class CancellationReason extends AbstractModel {
  @autoserialize
  name: string;

  @autoserialize
  description: string;

  @autoserialize
  useWithRideRequests: boolean;

  @autoserialize
  useWithReservations: boolean;

  @autoserialize
  systemOnly: boolean;
}
